import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { isAuthenticated, isSessionExpiredActive, initiateOAuthLogin } from './directOAuthHandler';

interface LoginRequiredProps {
  title?: string;
  children: React.ReactNode;
}

const LoginRequired: React.FC<LoginRequiredProps> = ({ children }) => {
  const authenticated = isAuthenticated();
  const redirectedRef = React.useRef(false);

  React.useEffect(() => {
    if (authenticated || isSessionExpiredActive()) return;
    if (window.location.search.includes('code=') || window.location.search.includes('error=')) return;
    if (redirectedRef.current) return;

    redirectedRef.current = true;
    initiateOAuthLogin();
  }, [authenticated]);

  if (!authenticated) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return <>{children}</>;
};

// HOC version
const requireLogin = (title?: string) => (WrappedComponent: React.ComponentType<any>) => {
  return (props: any) => (
    <LoginRequired title={title}>
      <WrappedComponent {...props} />
    </LoginRequired>
  );
};

export { LoginRequired };
export default requireLogin;
